/**
 * @GENERATED from Figma node 3638:51947
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GamingBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#7F776F"
      d="M13.047 7.908c-.564.564-.564 1.111 0 1.675.563.563 1.11.563 1.674 0 .564-.564.564-1.111 0-1.675-.563-.563-1.11-.563-1.674 0M17.233 7.07c-.563.564-.563 1.112 0 1.676.564.563 1.112.563 1.675 0 .564-.564.564-1.112 0-1.675-.563-.564-1.111-.564-1.675 0"
    />
    <path
      fill="#7F776F"
      fillRule="evenodd"
      d="m11.432 14.547 2.81-2.81 1.102.466c.627.265 1.189.291 1.763.122.613-.18 1.355-.62 2.22-1.486 1.224-1.224 1.592-2.188 1.592-2.93 0-.744-.368-1.708-1.592-2.932s-2.188-1.592-2.93-1.592c-.744 0-1.708.368-2.932 1.592L4.673 13.77C3.45 14.993 3.08 15.957 3.08 16.7s.37 1.707 1.593 2.931c1.224 1.224 2.188 1.593 2.93 1.593.744 0 1.708-.369 2.932-1.593.865-.865 1.305-1.607 1.486-2.22.17-.574.142-1.136-.123-1.762zm3.22-.709c1.975.836 3.933.254 5.93-1.743 2.818-2.817 2.818-5.556 0-8.374-2.816-2.817-5.555-2.817-8.373 0l-8.792 8.793C.6 15.33.6 18.07 3.417 20.886s5.556 2.817 8.374 0c1.997-1.997 2.578-3.956 1.743-5.93z"
      clipRule="evenodd"
    />
    <path
      fill="#7F776F"
      fillRule="evenodd"
      d="M6.348 16.7 5.3 15.654l1.256-1.256 1.047 1.046 1.047-1.046 1.256 1.256L8.86 16.7l1.047 1.047-1.256 1.256-1.047-1.047-1.047 1.047-1.256-1.256zM7.395 3.093a1.48 1.48 0 0 0 0 2.094l.628.628a3.257 3.257 0 0 1 0 4.605L5.51 12.932l-1.257-1.256 2.513-2.512a1.48 1.48 0 0 0 0-2.093l-.628-.628a3.257 3.257 0 0 1 0-4.606L6.976 1l1.256 1.256z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(GamingBright);
export { ForwardRef as GamingBright };
